import { Flex } from 'antd'
import React from 'react'

const DtcMappings = ({ title, mappings }) => (
  <div className='grid-col'>
    <div className='dtc-expanded-header'>
      {title}
    </div>
    <div className="dtc-expanded-cell">
      {mappings.map((mapping, index) => (
        <p key={`${mapping.name}-${index}`} className='dtc-detail'>
          <span className="dtc-name bolder underline">{mapping.name}</span>
          <span className="dtc-description">{mapping.description}</span>
        </p>
      ))}
    </div>
  </div>
)

export default DtcMappings
